import { Control } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../ui/components/ui/form';
import { Input } from '../../../../ui/components/ui/input';
import { FIELD_LABEL_CLASS } from '../../constants/offer-checkout.constants';
import { BankDetailsValidationResponseDto } from '../../types/response';
import CheckStatusIcon from '../check-status-icon/check-status-icon';
import { OfferCheckoutFormValues } from '../offer-checkout-form/offer-checkout-form.schema';

export interface SepaFieldsProps {
  control: Control<OfferCheckoutFormValues>;
  /** Result of the live check for the current values, `null` while unchecked. */
  checkResult: BankDetailsValidationResponseDto | null;
  isChecking: boolean;
  onBlur: () => void;
}

const SepaFields = ({ control, checkResult, isChecking, onBlur }: SepaFieldsProps) => (
  <div className="flex flex-col gap-3">
    {(['iban', 'bic'] as const).map((name) => (
      <FormField
        key={name}
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <FormLabel className={FIELD_LABEL_CLASS}>{name === 'iban' ? 'IBAN' : 'BIC'}</FormLabel>
            <div className="relative">
              <FormControl>
                <Input
                  {...field}
                  autoComplete="off"
                  className="bg-white pr-9"
                  onBlur={() => {
                    field.onBlur();
                    onBlur();
                  }}
                />
              </FormControl>
              <span className="absolute right-3 top-1/2 -translate-y-1/2">
                <CheckStatusIcon isChecking={isChecking} isValid={checkResult?.[name]} />
              </span>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    ))}
  </div>
);

export default SepaFields;
